module.exports = __webpack_public_path__ + "media/src/images/logo-6a9deaafc4082f967ef1763fbc612898.png";